// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ChartDataType;
(function (ChartDataType) {
    ChartDataType[ChartDataType["Default"] = 0] = "Default";
    ChartDataType[ChartDataType["Renco"] = 1] = "Renco";
    ChartDataType[ChartDataType["HeikinAshi"] = 2] = "HeikinAshi";
    ChartDataType[ChartDataType["Kagi"] = 3] = "Kagi";
    ChartDataType[ChartDataType["ThreeLinesBreak"] = 4] = "ThreeLinesBreak";
    ChartDataType[ChartDataType["TicTac"] = 5] = "TicTac";
    ChartDataType[ChartDataType["RencoNew"] = 6] = "RencoNew";
    ChartDataType[ChartDataType["VolumeRange"] = 7] = "VolumeRange";
})(ChartDataType || (ChartDataType = {}));
export var ChartHistoryType;
(function (ChartHistoryType) {
    ChartHistoryType[ChartHistoryType["Default"] = 0] = "Default";
    ChartHistoryType[ChartHistoryType["ByBid"] = 1] = "ByBid";
    ChartHistoryType[ChartHistoryType["ByBidAsk"] = 2] = "ByBidAsk";
    ChartHistoryType[ChartHistoryType["ByTrades"] = 3] = "ByTrades";
    ChartHistoryType[ChartHistoryType["ByASk"] = 4] = "ByASk";
})(ChartHistoryType || (ChartHistoryType = {}));
export var TerceraChartDrawingType;
(function (TerceraChartDrawingType) {
    TerceraChartDrawingType[TerceraChartDrawingType["Line"] = 0] = "Line";
    TerceraChartDrawingType[TerceraChartDrawingType["Bar"] = 1] = "Bar";
    TerceraChartDrawingType[TerceraChartDrawingType["Candle"] = 2] = "Candle";
    TerceraChartDrawingType[TerceraChartDrawingType["Dot"] = 3] = "Dot";
    TerceraChartDrawingType[TerceraChartDrawingType["DotLine"] = 4] = "DotLine";
    TerceraChartDrawingType[TerceraChartDrawingType["Forest"] = 5] = "Forest";
    TerceraChartDrawingType[TerceraChartDrawingType["Solid"] = 6] = "Solid";
    // EquiVolume  = 7,
    // CandleVolume  = 8,
    TerceraChartDrawingType[TerceraChartDrawingType["TicTac"] = 9] = "TicTac";
    TerceraChartDrawingType[TerceraChartDrawingType["Kagi"] = 10] = "Kagi";
    // искусственные
    TerceraChartDrawingType[TerceraChartDrawingType["LinesBreak"] = 11] = "LinesBreak";
    TerceraChartDrawingType[TerceraChartDrawingType["Renko"] = 12] = "Renko";
    TerceraChartDrawingType[TerceraChartDrawingType["Cluster"] = 13] = "Cluster";
    TerceraChartDrawingType[TerceraChartDrawingType["Profile"] = 14] = "Profile";
})(TerceraChartDrawingType || (TerceraChartDrawingType = {}));
/// <summary>
/// обмен данными между рендерерами
/// </summary>
export var TerceraChartRendererDrawingAdvancedParamsEnum;
(function (TerceraChartRendererDrawingAdvancedParamsEnum) {
    /// <summary>
    /// фоновые тулзы или поверх мейн прайс рендерера
    /// </summary>
    TerceraChartRendererDrawingAdvancedParamsEnum[TerceraChartRendererDrawingAdvancedParamsEnum["CurrentDrawingType"] = 0] = "CurrentDrawingType";
})(TerceraChartRendererDrawingAdvancedParamsEnum || (TerceraChartRendererDrawingAdvancedParamsEnum = {}));
export var TerceraChartToolRendererDrawingType;
(function (TerceraChartToolRendererDrawingType) {
    TerceraChartToolRendererDrawingType[TerceraChartToolRendererDrawingType["Background"] = 0] = "Background";
    TerceraChartToolRendererDrawingType[TerceraChartToolRendererDrawingType["Foreground"] = 1] = "Foreground";
})(TerceraChartToolRendererDrawingType || (TerceraChartToolRendererDrawingType = {}));
/// <summary>
/// Визуальная торговля с чарта
/// </summary>
export var TerceraChartTradingOperation;
(function (TerceraChartTradingOperation) {
    /// <summary>
    /// undefined
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["None"] = 0] = "None";
    /// <summary>
    /// Размещение нового ордера
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["PlaceNewOrder"] = 1] = "PlaceNewOrder";
    /// <summary>
    /// Отмена ордера, сл-ордера, тп-ордера
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["CancelOrder"] = 2] = "CancelOrder";
    /// <summary>
    /// Отмена ордера, сл-ордера, тп-ордера
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["CancelOrdersAccount"] = 3] = "CancelOrdersAccount";
    /// <summary>
    /// Отмена ордера, сл-ордера, тп-ордера
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["CancelOrdersSymbol"] = 4] = "CancelOrdersSymbol";
    /// <summary>
    /// исполнить как маркет
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["ChangeToMarket"] = 5] = "ChangeToMarket";
    /// <summary>
    /// был перетащен основной ордер и его сл/тп сместятся также
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["MoveOrder"] = 6] = "MoveOrder";
    /// <summary>
    /// ModifyOrderScreen показываем для переданного ордера, ппозиции
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["ModifyOrderPosition"] = 7] = "ModifyOrderPosition";
    /// <summary>
    /// Закрытие ппозиции
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["ClosePosition"] = 8] = "ClosePosition";
    /// <summary>
    /// Закрытие All
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["CloseAllPosition"] = 9] = "CloseAllPosition";
    /// <summary>
    /// Rollback ппозиции
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["RollbackPosition"] = 10] = "RollbackPosition";
    /// <summary>
    /// Добавить сл для ордера, позиции
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["PlaceSL"] = 11] = "PlaceSL";
    /// <summary>
    /// Добавить сл для ордера, позиции
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["PlaceTP"] = 12] = "PlaceTP";
    /// <summary>
    /// Изменение цены сл-ордера
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["ModifySL"] = 13] = "ModifySL";
    /// <summary>
    /// Изменение цены тп-ордера
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["ModifyTP"] = 14] = "ModifyTP";
    /// <summary>
    /// удалить сл
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["RemoveSL"] = 15] = "RemoveSL";
    /// <summary>
    /// удалить тп
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["RemoveTP"] = 16] = "RemoveTP";
    /// <summary>
    /// show menu
    /// </summary>
    TerceraChartTradingOperation[TerceraChartTradingOperation["ActionButton"] = 17] = "ActionButton";
    /// alert
    TerceraChartTradingOperation[TerceraChartTradingOperation["AlertReplacement"] = 18] = "AlertReplacement";
    TerceraChartTradingOperation[TerceraChartTradingOperation["EditAlert"] = 19] = "EditAlert";
    TerceraChartTradingOperation[TerceraChartTradingOperation["RemoveAlert"] = 20] = "RemoveAlert";
    TerceraChartTradingOperation[TerceraChartTradingOperation["ChartNewAlert"] = 21] = "ChartNewAlert";
    // PlaceSLL = 22, /// Добавить StopLossLimit #91413
    TerceraChartTradingOperation[TerceraChartTradingOperation["ModifySLL"] = 23] = "ModifySLL";
    TerceraChartTradingOperation[TerceraChartTradingOperation["RemoveSLL"] = 24] = "RemoveSLL";
    TerceraChartTradingOperation[TerceraChartTradingOperation["ModifyOrderQuantity"] = 25] = "ModifyOrderQuantity";
    TerceraChartTradingOperation[TerceraChartTradingOperation["ScrollToSelectedPrice"] = 26] = "ScrollToSelectedPrice";
    TerceraChartTradingOperation[TerceraChartTradingOperation["IsAllowOTHTrading"] = 27] = "IsAllowOTHTrading";
})(TerceraChartTradingOperation || (TerceraChartTradingOperation = {}));
